import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;
  flex-grow: 1;
  background-color: #ffff;
  height: 500px;
  z-index: 0;
  @media (max-width: 948px) {
    height: 100%;
  }
`

export const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`

export const MarkerLink = styled.a`
  position: relative;
  z-index: 21;
  pointer-events: auto;
  touch-action: manipulation;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: none;

  img {
    pointer-events: none;
    user-select: none;
  }
`

export const MapLegend = styled.div`
  position: absolute;
  left: 16px;
  bottom: 16px;
  z-index: 4;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 9px 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(4px);
  color: #4f565e;
  font-size: 11px;
  font-weight: 700;

  span {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  img {
    width: 16px;
    height: 19px;
    object-fit: contain;
  }

  @media (max-width: 640px) {
    left: 10px;
    bottom: 10px;
    gap: 9px;
    padding: 7px 9px;
    font-size: 9px;

    img {
      width: 14px;
      height: 17px;
    }
  }
`
